// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___GkvK7","root__wrapper":"style-module__root__wrapper___RqKka","root__item":"style-module__root__item___chjx_","root__item_name":"style-module__root__item_name___FlcAf","root__item_image":"style-module__root__item_image___TZM64","root__close":"style-module__root__close___jnPmd"};
    if(module.hot) {
      // 1697460476395
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  